module.exports = __webpack_public_path__ + "static/alex-knight-181471-unsplash-cf919dd8c4b4c5d770bd57ea7f030503.jpg";